<div id="testimonial">

    <div class="container">
        <div class="text-center" id="testimonial-title">
            <h2>PARENT'S APPRAISAL</h2>
            <hr>
        </div>
        <div class="carousel slide" id="testimonialCarousel" data-ride="carousel">
            <!-- Indicator -->
            <ol class="carousel-indicators">
                <li class="active indicator" data-target="#testimonialCarousel"
                data-slide-to="0"></li>
                <li class="indicator" data-target="#testimonialCarousel" data-slide-to="1"></li>
            </ol>
            <div class="carousel-inner">
                <div class="carousel-item active">
                    <div class="row d-flex">
                        <div class="col-lg-6">
                            <div id="testimonial-detail">
                                <img appLazyload src="/assets/img/testimonial/test1.jpeg" alt="person1" class="img-fluid">
                                <div id="main-content">
                                    <span><i class="fas fa-quote-left"></i></span>
                                    <h4>Siddharth Sachdeva</h4>
                                    <p>A very good school for any student's personal growth and everything becomes memorable when you have experienced the time in a place like this.</p>
                                    <span><i class="fas fa-quote-right float-right"></i></span>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div id="testimonial-detail">
                                <img appLazyload src="/assets/img/testimonial/test2.jpg" alt="person1" class="img-fluid">
                                <div id="main-content">
                                    <span><i class="fas fa-quote-left"></i></span>
                                    <h4>Ram Pal Mittan</h4>
                                    <p>Good school, surrounding Vasant Kunj, qualified staff, building sports ground are spacious. Lush green parks with plenty of plants. All facilities are available required far as school. </p>
                                    <span><i class="fas fa-quote-right float-right"></i></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="carousel-item">
                    <div class="row d-flex">
                        <div class="col-lg-6">
                            <div id="testimonial-detail">
                                <img appLazyload src="/assets/img/testimonial/test3.jpg" alt="person1" class="img-fluid">
                                <div id="main-content">
                                    <span><i class="fas fa-quote-left"></i></span>
                                    <h4>Atul Gupta</h4>
                                    <p>It's one of the best school in town Vasant Kunj and ever stood first in Academics as well as in Sports. Here students and mentors plays vital role in any type of activity enthusiastically.</p>
                                    <span><i class="fas fa-quote-right float-right"></i></span>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div id="testimonial-detail">
                                <img appLazyload src="/assets/img/testimonial/test4.jpg" alt="person1" class="img-fluid">
                                <div id="main-content">
                                    <span><i class="fas fa-quote-left"></i></span>
                                    <h4>Sahil Panchal</h4>
                                    <p>Suprb arrangments, loving teachers and principal Neelam Mam style awesome <br>
                                        Thanks for the alumini meet <br>
                                        Thanks a lot for reunion</p>
                                    <span><i class="fas fa-quote-right float-right"></i></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <a href="#testimonialCarousel" class="carousel-control-prev"
            data-slide="prev">
                <span class="carousel-control-prev-icon"></span>
            </a>
            <a href="#testimonialCarousel" class="carousel-control-next"
            data-slide="next">
                <span class="carousel-control-next-icon"></span>
            </a>
        </div>
        
    </div>
    <!-- <div class="container">
        <div class="text-center" id="testimonial-title">
            <h2>WHAT PARENT SAYS</h2>
            <hr class="pb-2">
        </div>
        <div class="carousel slide" id="slide3" data-ride="carousel"> -->
            <!-- Indicator -->
            <!-- <ol class="carousel-indicators">
                <li class="active indicator" data-target="#slide3"
                data-slide-to="0"></li>
                <li class="indicator" data-target="#slide3" data-slide-to="1"></li>
                <li class="indicator" data-target="#slide3" data-slide-to="2"></li>
            </ol> -->
            <!-- img appLazyload URL -->
            <!-- <div class="carousel-inner">
                <div class="carousel-item active">
                    <div class="row">
                        <div class="col-lg-6 col-md-6">
                            <div class="card">
                                
                                    <img src="/assets/img/testimonial/test4.jpg" alt="person1" class="img-fluid rounded-circle">
                              
                                <div class="card-body">
                                    <span><i class="fas fa-quote-left"></i></span>
                                    <h3 class="card-title">Umesh Goyal</h3>
                                    <p>
			                            Etiam non elit nec augue tempor gravida et sed velit. Aliquam tempus eget lorem ut malesuada. Phasellus dictum est sed libero posuere dignissim.
                                    </p>
                                    <span><i class="fas fa-quote-right float-right"></i></span>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6">
                            
                            <div class="card">
                                <img src="/assets/img/testimonial/test1.jpeg" alt="person1" class="img-fluid rounded-circle">

                                <div class="card-body">
                                    <span><i class="fas fa-quote-left"></i></span>
                                    <h3 class="card-title">Umesh Goyal</h3>
                                    <p>
			                            Etiam non elit nec augue tempor gravida et sed velit. Aliquam tempus eget lorem ut malesuada. Phasellus dictum est sed libero posuere dignissim.
                                    </p>
                                    <span><i class="fas fa-quote-right float-right"></i></span>
                                </div>
                            </div>
                            </div>
                    </div>
                </div>
                <div class="carousel-item">
                    <div class="row">
                        <div class="col-lg-6 col-md-6">
                            <div class="card">
                                <img src="/assets/img/testimonial/test2.jpg" alt="person1" class="img-fluid rounded-circle">
                                <div class="card-body">
                                    <span><i class="fas fa-quote-left"></i></span>
                                    <h3 class="card-title">Umesh Goyal</h3>
                                    <p>
			                            Etiam non elit nec augue tempor gravida et sed velit. Aliquam tempus eget lorem ut malesuada. Phasellus dictum est sed libero posuere dignissim.
                                    </p>
                                    <span><i class="fas fa-quote-right float-right"></i></span>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6">
                            <div class="card">
                                <img src="/assets/img/testimonial/test3.jpg" alt="person1" class="img-fluid rounded-circle">
                                <div class="card-body">
                                    <span><i class="fas fa-quote-left"></i></span>
                                    <h3 class="card-title">Umesh Goyal</h3>
                                    <p>
			                            Etiam non elit nec augue tempor gravida et sed velit. Aliquam tempus eget lorem ut malesuada. Phasellus dictum est sed libero posuere dignissim.
                                    </p>
                                    <span><i class="fas fa-quote-right float-right"></i></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div> -->
            <!-- controller -->
            <!-- <a href="#slide3" class="carousel-control-prev"
            data-slide="prev">
                <span class="carousel-control-prev-icon"></span>
            </a>
            <a href="#slide3" class="carousel-control-next"
            data-slide="next">
                <span class="carousel-control-next-icon"></span>
            </a>
        </div>
        
    </div> -->
</div>